import { component } from "picoapp";

export const buildViewProductDetailsPayload = (dataset: DOMStringMap) => ({
  "product category": dataset.mtrProductCategory,
  "product id": dataset.mtrProductId,
  "product name": dataset.mtrProductName,
  "product price": dataset.mtrProductPrice,
  "variant id": dataset.mtrVariantId,
  "variant name": dataset.mtrVariantName,
  "variant price": dataset.mtrVariantPrice,
  "variant sku": dataset.mtrVariantSku,
  "bundle name": dataset.mtrBundleName,
  source: window.location.href,
  market: dataset.mtrMarket,
  ...(dataset.mtrAddonProductNames && {
    "add-on product names": JSON.parse(
      dataset.mtrAddonProductNames
    ) as string[],
  }),
});

export const productTracker = component((node: HTMLElement) => {
  const viewedProductDetailsData = buildViewProductDetailsPayload(node.dataset);

  const viewedProductdata = {
    Name: node.dataset.mtrProductName,
    ProductID: node.dataset.mtrProductId,
    Categories: node.dataset.mtrProductCategory,
    ImageURL: node.dataset.mtrProductImageUrl,
    URL: node.dataset.mtrProductUrl,
    Brand: node.dataset.mtrProductBrand,
    Price: node.dataset.mtrProductPrice,
    CompareAtPrice: node.dataset.mtrProductCompareAtPrice,
    Market: node.dataset.mtrMarket,
    Currency: node.dataset.mtrCurrency,
  };

  window.maestro.fireTrackEvent("viewProductDetails", viewedProductDetailsData);
  window.maestro.fireTrackEvent("viewedProduct", viewedProductdata);
});
